<template>
    <div class="col-12">
        <template v-if="hasExistingLeases()">
            <h4 class="headingLevel mb-4">{{ getTranslation('licence-configurator', 'subscription_options') }}</h4>

            <template v-if="hasNewPrograms()">
                <!-- attach new programs to existing leases-->
                <b-form-radio
                    :id="'lease_custom_' + product.id"
                    :name="'configure_period_'+ product.id"
                    v-model="leaseOptions.selectedOption"
                    value="1"
                    class="mb-3 ml-5"
                >
                    <span class="font-weight-medium">{{ getTranslation('licence-configurator', 'attach_to_existing_subscription') }}</span>

                </b-form-radio>
                <div class="ml-5">
                    <div class="ml-5"
                         :class="leaseOptions.selectedOption !=1 ? 'd-none' : ''"
                    >
                        <select2
                            class="form-select" style = "width: 200px"
                            :name="'mergeNewSoftwareExistingLease_' + product.id"
                            :id="'mergeNewSoftwareExistingLease_' + product.id"
                            data-theme="bootstrap4"
                            :value="leaseUniqueDates[product.id][0]"
                            :disabled="leaseOptions.selectedOption !=1"
                            @input="setMergeSingle($event)"
                        >
                            <option
                                v-for="date in leaseUniqueDates[product.id]" :key="date" :value="date"
                                :selected="leaseOptions.selected"
                            >
                                {{ date }}</option>
                        </select2>
                    </div>
                </div>
            </template>
            <template v-else>
                <!-- prolong existing leases by 1 year-->
                <b-form-radio
                    :id="'lease_custom_' + product.id"
                    :name="'configure_period_'+ product.id"
                    v-model="leaseOptions.selectedOption"
                    value="4"
                    class="mb-3 ml-5"
                    @change="prolongOneYear()"
                >
                    <span class="font-weight-medium">{{ getTranslation('licence-configurator', 'prolong_selected_subscription_by_one_year') }}</span>
                </b-form-radio>
                <div class="ml-5">
                    <div class="ml-5"
                         :class="leaseOptions.selectedOption !=4 ? 'd-none' : ''"
                    >
                        <div
                            class="custom-control custom-checkbox b-custom-control-lg mb-4"
                            v-for="date in leaseUniqueDates[product.id]" :key="date"
                        >
                            <input
                                type="checkbox"
                                :id="'mergeNewSoftwareExistingLease_' + date"
                                :name="'mergeNewSoftwareExistingLease_' + date"
                                class="custom-control-input"
                                @click="prolongOneYear(date)"
                                :value="date"
                                :checked="leaseOptions.dates && leaseOptions.dates.includes(date) && leaseOptions.selectedOption ==4"
                            >

                            <label :for="'mergeNewSoftwareExistingLease_' + date" class="custom-control-label d-flex flex-wrap" style="font-size: 16px;">
                                <span style="font-weight: 400;">{{ date }}</span>&nbsp;-&nbsp;{{ getProgramText(date) }}
                            </label>
                        </div>
                    </div>

                </div>
            </template>

            <div class="ml-5">
                <!-- attach new programs to existing leases and merge leases -->
                <template v-if="Object.keys(leaseUniqueDates[product.id]).length > 1">
                <b-form-radio
                    :id="'lease_merge_' + product.id"
                    :name="'configure_period_'+ product.id"
                    v-model="leaseOptions.selectedOption"
                    value="2"
                    class="mb-3 mt-4"
                    @change="addLeaseMerge(false)"
                >
                    <template v-if="hasNewPrograms()">
                        <span class="font-weight-medium mb-4">{{ getTranslation('licence-configurator', 'merge_new_license_and_existing_subscriptions') }}</span>
                    </template>

                    <template v-else>
                        <span class="font-weight-medium mb-4">{{ getTranslation('licence-configurator', 'merge_subscriptions') }}</span>
                    </template>
                </b-form-radio>

                <div
                    class="custom-control custom-checkbox b-custom-control-lg mb-4 ml-5"
                    v-for="date in leaseUniqueDates[product.id]" :key="date"
                    :class="leaseOptions.selectedOption !=2 ? 'd-none' : ''"
                >
                    <input
                        type="checkbox"
                        :id="'lease_merge_' + product.id + '_' + date"
                        class="custom-control-input"
                        :name="'lease_merge_' + product.id + '_' + date"
                        :disabled="true"
                        onclick="return false;"
                        :value="date"
                        :checked="leaseOptions.dates && leaseOptions.dates.includes(date) && leaseOptions.selectedOption ==2"
                    >
                    <!-- @click="addLeaseMerge($event)"-->
                    <label :for="'lease_merge_' + product.id + '_' + date" class="custom-control-label d-flex flex-wrap" style="font-size: 16px;">
                        <span style="font-weight: 400;">{{ date }}</span>&nbsp;-&nbsp;{{ getProgramText(date) }}
                    </label>
                </div>
            </template>
            </div>



        </template>

        <template v-if="!hasExistingLeases()">
            <h4 class="headingLevel mb-4 ">{{ getTranslation('licence-configurator', 'new_subscription_renewal_date') }}</h4>
        </template>

        <template v-if="hasNewPrograms()">
            <b-form-radio
                :id="'lease_oneYear_' + product.id"
                :name="'configure_period_'+ product.id"
                v-model="leaseOptions.selectedOption"
                value="3"
                class="mb-3 mt-4 ml-5"
            >
                <span class="font-weight-medium">{{ getTranslation('licence-configurator', 'create_new_subscription_one_year') }}</span>
            </b-form-radio>
        </template>

        <h4 class="headingLevel mb-4 mt-5">
            <div class="custom-control custom-checkbox b-custom-control-lg mb-1">
                <input
                    type="checkbox"
                    :id="'show_date_' + product.id"
                    v-model="leaseOptions.showDatePicker"
                    @change="updateLeaseDatePicker($event)"
                    class="custom-control-input"
                >
                <label :for="'show_date_' + product.id" class="custom-control-label d-flex flex-wrap" >
                    {{ getTranslation('licence-configurator', 'customize_next_subscription_renewal_date') }}
                </label>
            </div>
        </h4>

        <div class="ml-5 mb-5">
            <div
                :class="leaseOptions.showDatePicker === true ? 'mt-4' : 'd-none'"
            >
                <label :for="'customDate_' + product.id" class="form-label font-weight-medium mb-2">{{ getTranslation('licence-configurator', 'set_custom_end_date') }}</label>
                <input
                    type="date"
                    :id="'customDate_' + product.id"
                    class="form-control d-inline-block"
                    style="width: 200px; font-size: 16px;"
                    :value="getCalendarDefaultDate()"
                    :min="getCalendarMinDate()"
                    :max="getCalendarMaxDate()"
                    @input="selectCustomDate($event)"
                    placeholder="Select custom end date"
                    onkeydown="return false"
                >
            </div>
        </div>
    </div>
</template>

<script>

export default {
        methods: {
            isValidDate(dateInput) {
                const dateObj = new Date(dateInput);
                // Check if the input resulted in an "Invalid Date"
                if (isNaN(dateObj.getTime())) { // or simply isNaN(dateObj) in many cases
                    return false;
                }
                // Optional: Add more specific checks here if you need to validate specific formats or ranges
                return true;
            },
            getCalendarMinDate() {
                if (this.leaseOptions.minDate && this.isValidDate(this.leaseOptions.minDate)) {
                    return this.leaseOptions.minDate;
                }
                let d = this.getFormattedDate();
                return this.addYears(d);
            },
            getCalendarMaxDate() {
                if (this.leaseOptions.maxDate && this.isValidDate(this.leaseOptions.maxDate)) {
                    return this.leaseOptions.maxDate;
                }
                let d = this.getFormattedDate();
                return this.addYears(d, 3);
            },
            getCalendarDefaultDate() {
                if (this.leaseOptions.customDate && this.isValidDate(this.leaseOptions.customDate)) {
                    return this.leaseOptions.customDate;
                }
                if (this.leaseOptions.minDate && this.isValidDate(this.leaseOptions.minDate)) {
                    return this.leaseOptions.minDate;
                }
                let d = this.getFormattedDate();
                return this.addYears(d);
            },

            updateLeaseDatePicker() {
                this.resetDatePicker();
                let value = this.getOptionValue('customDate');
                let daysDiff = false;
                if (value) {
                    daysDiff = this.daysBetween(this.getFormattedDate(), value);
                }
                if (this.leaseOptions.showDatePicker === false) {
                    this.leaseOptions.customDate = false;
                }

                this.updateCartPrograms(daysDiff);
                this.deleteCartProlongData();
                this.updateLeaseConfig();
                this.updateLeaseOptions(this.leaseOptions);
            },

            hasNewPrograms() {
                let self = this;
                if (this.isTruss4Product(this.product.id)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.programs)) {
                    return false;
                }
                let index = _.findIndex(this.$store.state.cart.programs, function(p) { return p.product === self.product.id; });
                return index >= 0;
            },
            hasExistingLeases() {
                let self = this;
                let index = _.findIndex(this.leaseData, (l) => { return l.product == self.product.id; }, 0);
                return index >= 0;
            },
            getInputMaxDate() {
                let now = new Date();
                return this.getFormattedDate(new Date(now.setFullYear(now.getFullYear() + 3)));
            },
            getInputMinDate(date) {
                return date;
            },
            treatAsUTC(date) {
                return new Date(date);
                //result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                // return result;
            },
            daysBetween(startDate, endDate) {
                let millisecondsPerDay = 24 * 60 * 60 * 1000;
                let ret = (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
                return Math.ceil(ret);
            },
            addYears(date, years = 1) {
                // Create a copy of the original date to prevent mutation
                const newDate = new Date(date);
                // Get the current year, add 1, and set the new year
                newDate.setFullYear(newDate.getFullYear() + years);
                return this.getFormattedDate(newDate);
            },
            compareDates(date1, date2) {
                if (date1 === date2) {
                    return 0;
                } else if (this.daysBetween(date1, date2) > 0) {
                    return 1
                } else {
                    return -1;
                }
            },
            getFormattedDate(date = false) {
                if (date === false) {
                    date = new Date();
                }
                let year = date.getFullYear();
                // Month is 0-indexed, so add 1
                let month = String(date.getMonth() + 1).padStart(2, '0');
                let day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            updateCartPrograms(value) {
                let self = this;
                if (_.isNil(value) || _.isNaN(value)) {
                    value = false;
                }
                _.forEach(this.$store.state.cart.programs, function(p) {
                    if (p.product === self.product.id) {
                        let payload = {
                            id: p.id,
                            upgrade: value,
                            column: 'days'
                        }
                        self.$store.commit('upgradeCartProgram', payload);
                    }
                });
            },
            updateLeaseOptions(data) {
                if (_.isNil(data) && _.isNil(data.showDatePicker)) {
                    data.showDatePicker = false;
                }

                if (_.isNil(data) && _.isNil(data.showPerpetualUpgrade)) {
                    data.showPerpetualUpgrade = false;
                }

                let payload = {
                    id: this.product.id,
                    data: data,
                }

                this.$store.commit('updateLeaseOptions', payload);
            },

            getProgramText(date) {
                let self = this;
                let allPrograms = _.filter(this.licences, function(l) { return (l.lease_end == date && l.product == self.product.id); });
                let programs = _.uniqBy(allPrograms, 'program_id');


                let pr = [];
                _.forEach(programs, function (p) {
                    let name = p.program_name;

                    let totalQty = _.sumBy(allPrograms, (item) => {
                        return item.program_id === p.program_id ? item.quantity : 0;
                    });

                    if (totalQty > 1) {
                        name = totalQty + 'x '  + p.program_name;
                    }
                    pr.push(name);
                })
                return pr.join(", ");
            },
            deleteCartProlongData() {
                //reset cart step
                this.resetCartStep();

                //delete the lease merge data
                let payload = {product: this.product.id};
                this.$store.commit('deleteLeaseProlongConfig', payload);
            },

            resetCartStep() {
                let payload = {'step': 2};
                this.$store.commit('setCartStep', payload);
            },
            resetDatePicker(minDate = false) {
                if (this.leaseOptions.minDate) {
                    minDate = this.leaseOptions.minDate;
                }
                let customDateContainer = $('#customDate_' + this.product.id);
                customDateContainer.val('');
                this.leaseOptions.customDate = false;
                if (minDate) {
                    customDateContainer.attr('min', minDate);
                    this.leaseOptions.minDate = minDate;
                    this.leaseOptions.customDate = minDate;
                }
            },
            updateLeaseConfig() {
                let self = this;
                if (this.leaseOptions.selectedOption === 4) {
                    let allDates = _.clone(this.leaseOptions.dates);

                    let licences =_.filter(this.licences, function(l) { return (l.product === self.product.id && allDates.includes(l.lease_end)); });
                    _.forEach(licences, function (l) {
                        let maxDate = self.addYears(l.lease_end, 1);
                        if (self.leaseOptions.customDate) {
                            maxDate = self.leaseOptions.customDate
                        }

                        let daysDiff = self.daysBetween(l.lease_end, maxDate);
                        let payload = {
                            program_id: l.program_id,
                            discount: l.discount,
                            user_licence_id: l.user_licence_id,
                            leaseId: l.leaseId,
                            lease_end: l.lease_end,
                            lease_end_new: maxDate,
                            product: l.product,
                            daysDiff: daysDiff,
                            sort_order: l.sort_order,
                            quantity: l.quantity,
                        }
                        self.$store.commit('createLeaseProlongConfig', payload);

                    });
                } else {
                    let allDates = _.clone(this.leaseOptions.dates);

                    if (this.leaseOptions.customDate) {
                        allDates.push(this.leaseOptions.customDate);
                    }
                    let maxDate = this.getFormattedDate(new Date(Math.max(...allDates.map(date => new Date(date)))));

                    let licences =_.filter(this.licences, function(l) { return (l.product === self.product.id); });
                    _.forEach(licences, function (l) {
                        if ((self.compareDates(l.lease_end, maxDate) > 0) && self.leaseOptions.dates.includes(l.lease_end)) {
                            let daysDiff = self.daysBetween(l.lease_end, maxDate);
                            let payload = {
                                program_id: l.program_id,
                                discount: l.discount,
                                user_licence_id: l.user_licence_id,
                                leaseId: l.leaseId,
                                lease_end: l.lease_end,
                                lease_end_new: maxDate,
                                product: l.product,
                                daysDiff: daysDiff,
                                sort_order: l.sort_order,
                                quantity: l.quantity,
                            }
                            self.$store.commit('createLeaseProlongConfig', payload);
                        }
                    })
                }
            },
            getOptionValue(column) {
                if (_.isNil(this.leaseOptions) || _.isNil(this.leaseOptions[column]) ) {
                    return false;
                }
                return this.leaseOptions[column];
            },
            setMergeSingle(selected = false) {
                //get selected value
                if (selected === false) {
                    if (!this.hasNewPrograms()) {
                        selected = _.last(this.leaseUniqueDates[this.product.id]);
                    } else {
                        selected = this.leaseUniqueDates[this.product.id][0];
                    }

                }

                let daysDiff = this.daysBetween(this.getFormattedDate(), selected);
                //reset date picker selected date
                //update date picker min date
                this.resetDatePicker(selected);

                //reset cart prolong options
                this.deleteCartProlongData();

                //update the date for cart programs
                this.updateCartPrograms(daysDiff);

                if (!this.hasNewPrograms()) {
                    // custom date - date + 1 year
                    // min date custom date + 1 year
                    // max date = min date custom date + 1 year

                    this.leaseOptions = {
                        oneYear: false,
                        merge: false,
                        customDate: this.addYears(selected),
                        selectedDate: selected,
                        daysDifference: false,
                        selectedOption: 1,
                        dates: [selected],
                        maxDate: this.addYears(selected, 3),
                        minDate: this.addYears(selected),
                        showDatePicker: this.getOptionValue('showDatePicker'),
                        showPerpetualUpgrade: this.getOptionValue('showPerpetualUpgrade')
                    }
                    this.updateLeaseOptions(this.leaseOptions);
                    this.updateLeaseConfig();
                    return false;
                }

                this.leaseOptions = {
                    oneYear: false,
                    merge: false,
                    customDate: selected,
                    daysDifference: false,
                    selectedOption: 1,
                    dates: [selected],
                    maxDate: this.getInputMaxDate(),
                    minDate: this.getInputMinDate(selected),
                    showDatePicker: this.getOptionValue('showDatePicker'),
                    showPerpetualUpgrade: this.getOptionValue('showPerpetualUpgrade')
                }
                this.updateLeaseOptions(this.leaseOptions);
            },
            addLeaseMerge(event = false) {
                let self = this;
                let dates = this.leaseOptions.dates;

                if (event === false) {
                    //on click radio, select all dates
                    let temp = this.leaseUniqueDates[this.product.id];
                    if (_.isObject(temp)) {
                        dates = Object.values(temp);
                    } else {
                        dates = this.leaseUniqueDates[this.product.id];
                    }

                } else {
                    //on click checkbox, decide if remove or add
                    let currentDate = event.target.value;

                    if (dates.includes(currentDate)) {
                        // remove the date
                        dates = dates.filter(d => d !== currentDate);
                    } else {
                        dates.push(currentDate);
                    }
                }

                this.deleteCartProlongData();

                let daysDiff = false;
                let maxDate = this.getFormattedDate(new Date(Math.max(...dates.map(date => new Date(date)))));

                if (_.isEmpty(dates)) {
                    this.updateCartPrograms(false);
                } else {
                    daysDiff = this.daysBetween(this.getFormattedDate(), maxDate);
                    this.updateCartPrograms(daysDiff);
                }

                this.resetDatePicker(maxDate);

                this.leaseOptions = {
                    oneYear: false,
                    merge: true,
                    customDate: maxDate,
                    daysDifference: false,
                    selectedOption: 2,
                    dates: dates,
                    minDate: this.getInputMinDate(maxDate),
                    maxDate: this.getInputMaxDate(),
                    showDatePicker: this.getOptionValue('showDatePicker'),
                    showPerpetualUpgrade: this.getOptionValue('showPerpetualUpgrade')
                }
                this.updateLeaseOptions(this.leaseOptions);
                this.updateLeaseConfig();
            },
            setOneYear() {
                this.resetDatePicker();

                //reset cart prolong options
                this.deleteCartProlongData();

                this.updateCartPrograms(false);

                let now = new Date();
                let minDate = this.getFormattedDate(new Date(now.setFullYear(now.getFullYear() + 1)));

                this.leaseOptions = {
                    oneYear: true,
                    merge: false,
                    customDate: minDate,
                    daysDifference: false,
                    selectedOption: 3,
                    dates: [],
                    minDate: minDate,
                    maxDate: this.getInputMaxDate(),
                    showDatePicker: this.getOptionValue('showDatePicker'),
                    showPerpetualUpgrade: this.getOptionValue('showPerpetualUpgrade')
                };
                this.updateLeaseOptions(this.leaseOptions);
            },
            prolongOneYear(selected = false) {
                //get selected value
                let dates = [];
                if (!_.isNil(this.leaseOptions) && !_.isNil(this.leaseOptions.dates) && selected) {
                    dates = this.leaseOptions.dates;
                }

                if (selected === false) {
                    selected = _.last(this.leaseUniqueDates[this.product.id]);
                }

                //reset cart prolong options
                this.deleteCartProlongData();
                // custom date - date + 1 year
                // min date custom date + 1 year
                // max date = min date custom date + 1 year

                if (dates.includes(selected)) {
                    // remove the date
                    dates = dates.filter(d => d !== selected);
                } else {
                    dates.push(selected);
                }

                let maxDate = this.getFormattedDate(new Date(Math.max(...dates.map(date => new Date(date)))));

                let customDate = false;
                if (this.leaseOptions.showDatePicker === true) {
                    customDate = this.addYears(maxDate);
                }

                this.resetDatePicker(selected);
                this.leaseOptions = {
                    oneYear: false,
                    merge: false,
                    customDate: customDate,
                    selectedDate: selected,
                    daysDifference: false,
                    selectedOption: 4,
                    dates: dates,
                    maxDate: this.getInputMaxDate(),
                    minDate: this.addYears(maxDate),
                    showDatePicker: this.getOptionValue('showDatePicker'),
                    showPerpetualUpgrade: this.getOptionValue('showPerpetualUpgrade')
                }
                this.updateLeaseOptions(this.leaseOptions);
                this.updateLeaseConfig();
                return false;
            },
            selectCustomDate(event) {
                let selectedDate = event.target.value;
                let dates = this.leaseOptions.dates;
                let maxDate = this.getFormattedDate();
                if (!_.isEmpty(dates)) {
                    maxDate = this.getFormattedDate(new Date(Math.max(...dates.map(date => new Date(date)))));
                }

                //selected date cannot be lower than maxDate
                if (this.compareDates(selectedDate, maxDate) > 0) {
                    this.resetDatePicker();
                    return false;
                }

                this.leaseOptions.customDate = selectedDate;
                this.updateLeaseOptions(this.leaseOptions);
                this.deleteCartProlongData();
                this.updateLeaseConfig();

                let daysDiff = this.daysBetween(this.getFormattedDate(), selectedDate);
                this.updateCartPrograms(daysDiff);
            },
        },
        beforeMount() {
            if (!_.isArray(this.leaseUniqueDates[this.product.id])) {
                this.leaseUniqueDates[this.product.id] = Object.values(this.leaseUniqueDates[this.product.id]);
            }
            this.leaseUniqueDates[this.product.id].sort((a, b) => {
                // Convert strings to Date objects and subtract them
                // b - a sorts in descending order (newest first)
                return new Date(b) - new Date(a);
            });

            if (_.isNil(this.$store.state.cart.leaseOptions[this.product.id]) || _.isEmpty(this.$store.state.cart.leaseOptions[this.product.id])) {
                if (this.hasExistingLeases()) {
                    if (this.hasNewPrograms()) {
                        this.setMergeSingle();
                    } else {
                        this.prolongOneYear()
                    }
                } else {
                    this.setOneYear();
                }

            } else {
                this.leaseOptions = this.$store.state.cart.leaseOptions[this.product.id];
            }
        },
        mounted() {

        },

        watch: {
            'leaseOptions.selectedOption'(newValue, oldValue) {
                if (newValue === '1') {
                    this.setMergeSingle(false);
                } else if (newValue === '3') {
                    this.setOneYear(false);
                }
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                leaseData: JSON.parse(window.leaseData),
                leaseUniqueDates: JSON.parse(window.leaseUniqueDates),
                referenceDates: JSON.parse(window.referenceDates),
                leaseOptions: {},
                licences: JSON.parse(window.licences),
            };
        },
        props: {
            product: Object,
        }
    }
</script>

<style>

.select2-search__field {
    display: none;
}
</style>
